import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import '@/static/css/CustomVuetify.scss';

import customColors from '@/static/js/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#817EC4',
        secondary: '#F9F9F9',
        tertiary: '#F9F9F9',
        accent: '#817EC4',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        basetext: '#4b4944',
        ...customColors,
      },
      dark: {
        primary: '#212121',
        secondary: '#4b4944',
        tertiary: '#212121',
        accent: '#817EC4',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        basetext: '#FFFFFF',
        ...customColors,
      },
    },
    options: {
      customProperties: true,
    },
  },
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 800,
      lg: 960,
      xl: 1280,
    },
    scrollBarWidth: 24,
  },
});
